var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"font-weight-black caption mt-0 main-button",style:(`height:50px; font-weight: 900; width: ${_vm.width ||
      '100%'}; ${_vm.additionalStyles}`),attrs:{"loading":_vm.loading,"outline":_vm.outline,"flat":_vm.flat,"href":_vm.href,"round":"","block":"","large":"","dark":"","width":"20px","depress":"","color":"primary","disabled":_vm.disabled}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }